// Copyright (c) 2023 WiseTime. All rights reserved.

import React from "react"
import styled from "styled-components/macro"
import { Trans } from "@lingui/react"
import { shortcuts } from "../../../app/shortcuts"

const Wrapper = styled.div`
  color: ${({ theme }) => theme.colors.darkGray};
  text-align: center;
  line-height: 26px;
  margin-bottom: 1.6rem;

  @media (max-width: ${({ theme }): string => theme.screen.sm}) {
    display: none;
  }
`

const DndTip = styled.p`
  line-height: normal;
  margin: 0;
`

const Shortcut = styled.span`
  position: relative;
  display: inline-block;
  padding: 0 7px;
  width: 26px;
  height: 26px;
  vertical-align: -5px;
  border: 1px solid ${({ theme }) => theme.colors.darkGray};
  border-radius: 5px;
  margin: 0 4px;
`

const Character = styled.span`
  font-size: 50px;
  position: absolute;
  top: 14px;
  left: 0;
`

type Props = {
  className?: string,
}

const TimesheetDrawerTip = ({ className }: Props) => (
  <Wrapper className={className}>
    <Trans
      id="label_timesheet_drawer_tip"
      message="Press backtick <0><1>{shortcut}</1></0> at any time to toggle the timesheet drawer."
      values={{
        shortcut: shortcuts.timesheetsConsole,
      }}
      components={[
        <Shortcut key="0"/>,
        <Character key="1"/>,
      ]}
    />
    <DndTip>
      <Trans
        id="label_time_rows_dnd_tip"
        message="You can also select timeline rows and drag them to the timesheet area."
      />
    </DndTip>
  </Wrapper>
)

export default TimesheetDrawerTip
